export const API_STATES = {
  PRISTINE: 'pristine',
  IN_PROGRESS: 'in-progress',
  DONE: 'done'
}
